export const DCM_TAG_SHEET_PARSE_ENDPOINT = '/api/dcm-tag-sheet/parse';
